import { Box, Button, Checkbox, Group, Modal, UnstyledButton } from '@mantine/core';
import { useEffect, useState } from 'react';

import { Declaration, DeclarationGoods, ISaveNotes } from '@e-origin/shared';

import { checkMarkIcon, closeIcon } from '@assets';
import { riskAnalysisService } from '../../../../services';
import classes from './RiskAnalysisNotes.module.css';

interface RiskAnalysisNotesProps {
  opened: boolean;
  onHide(data?: ISaveNotes): void;
  goodDetails: DeclarationGoods;
  declaration: Declaration;
}

export const RiskAnalysisNotes: React.FC<RiskAnalysisNotesProps> = (props) => {
  const [customsDecisionChecked, setCustomsDecisionChecked] = useState(!!props.goodDetails.evalMethodAiHsCode.annotationCustomsDecision);
  const [notes, setNotes] = useState(props.goodDetails.evalMethodAiHsCode.annotationNote || '');
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);

  const [cursorPosition, setCursorPosition] = useState(props.goodDetails.evalMethodAiHsCode.annotationNote?.length || 0);

  useEffect(() => {
    setSaveButtonDisabled(
      notes === props.goodDetails.evalMethodAiHsCode.annotationNote &&
        customsDecisionChecked === !!props.goodDetails.evalMethodAiHsCode.annotationCustomsDecision,
    );
  }, [notes, customsDecisionChecked]);

  const saveNotes = async () => {
    if (saveButtonDisabled) {
      props.onHide();
      return;
    }

    if (props.declaration?._id && props.goodDetails) {
      const webUrl = props.goodDetails.webScraping?.webUrl;
      const goodItemsIds = props.declaration.goodsShipmentItems.filter((good) => good.webScraping?.webUrl === webUrl).map((good) => good._id);

      await riskAnalysisService.saveNotes(goodItemsIds, {
        notes,
        customsDecisionChecked,
      });
      props.onHide({ notes, customsDecisionChecked });
      return;
    }
    props.onHide();
  };

  return (
    <>
      <Modal opened={props.opened} onClose={props.onHide} zIndex={9999} centered withCloseButton={false}>
        <Box className={classes.riskAnalysisNotesHeader}>
          <Group className={classes.checkboxContainer}>
            <Checkbox
              type="checkbox"
              onChange={(event) => setCustomsDecisionChecked(event.target.checked)}
              checked={customsDecisionChecked}
              classNames={{ input: classes.pointerCursor }}
              size="md"
            />
            <p>Customs decision</p>
          </Group>
          <Group className={classes.riskAnalysisNotesActions}>
            <Button
              h="auto"
              py={5}
              px={10}
              key="save-notes"
              type="button"
              onClick={async () => saveNotes()}
              disabled={saveButtonDisabled}
              variant="filled"
              size="lg"
            >
              <img src={checkMarkIcon} width={24} />
            </Button>
            <UnstyledButton onClick={async () => props.onHide()}>
              <img src={closeIcon} alt="" />
            </UnstyledButton>
          </Group>
        </Box>
        <Box className={classes.riskAnalysisNotesContent}>
          <textarea
            placeholder="Write some notes here.."
            autoFocus={true}
            onChange={(event) => {
              setCursorPosition(event.target.selectionStart);
              setNotes(event.target.value);
            }}
            onFocus={(event) => {
              event.target.selectionStart = cursorPosition;
            }}
            value={notes}
          ></textarea>
        </Box>
      </Modal>
    </>
  );
};
